import { ThreadResponse } from "../contracts/ThreadResponse";
import { MessageThread } from "../models/MessageThread";

/** Maps thread responses from the API to frontend models. */
export class ThreadResponseMapper {
  toThread = (response: ThreadResponse): MessageThread => ({
    id: response.id,
    kind: response.kind,
    subjectId: response.subjectId,
    title: response.title,
    lastMessageAt: response.lastMessageAt ? new Date(response.lastMessageAt) : null,
    lastMessagePreview: response.lastMessagePreview ?? null,
    unreadCount: response.unreadCount,
    participantNames: response.participantNames ?? [],
    participantCount: response.participantCount ?? 0,
    hostName: response.hostName ?? null,
    isMuted: response.isMuted ?? false,
    staffOnly: response.staffOnly ?? false,
    counterpartOnline: response.counterpartOnline ?? null,
    messagesStopped: response.messagesStopped ?? false,
  });

  toThreads = (responses: ThreadResponse[]): MessageThread[] => responses.map(this.toThread);
}
